import LandlordReview from './LandlordReview';

export default LandlordReview;
